import type { InterstateOnChangeEvent } from '@interstate/components/InterstateEvents';

export const getNumericValue = (event: InterstateOnChangeEvent<string>): number | undefined => {
    return event.target.value !== '' ? Number(event.target.value) : undefined;
};
